module.exports = __webpack_public_path__ + "img/camp-logo.5e70b9e0.png";